import styled, { css } from 'styled-components';
import { suppressProps } from '../../utils/index.js';
import { EmptyState } from '../empty-state/empty-state.component.js';
import { Label } from '../label/index.js';
import { TextElement } from '../text/text.styles.js';
export const ListBoxElement = styled.ul.withConfig(suppressProps('onScrollRevealLastItem', 'defaultSelectedKeys', 'shouldUseVirtualFocus', 'loading', 'options'))(({ theme }) => {
    const { backgroundColor } = theme.styles.listBoxes.base;
    return css `
    margin: ${theme.space.x0};
    background: ${backgroundColor};
    padding: ${theme.space.x0};
  `;
});
export const getListBoxItemInactiveStyles = ({ theme }) => {
    const { color, backgroundColor } = theme.styles.listBoxItems.states.inactive;
    return css `
    color: ${theme.colors.controls[color]};
    background-color: ${theme.colors.backgrounds[backgroundColor]};
  `;
};
const getListBoxItemHoveredStyles = ({ theme, disablePointerEvents, }) => {
    const { color, backgroundColor } = theme.styles.listBoxItems.states.hovered;
    return css `
    &:hover {
      color: ${theme.colors.controls[color]};
      background-color: ${theme.colors.backgrounds[backgroundColor]};
    }
    ${disablePointerEvents && 'pointer-events: none'};
  `;
};
const getListBoxItemFocusedStyles = ({ theme, isFocused }) => {
    const outlineStyle = css `
    outline: ${theme.outlines.item.rule};
    outline-offset: ${theme.outlines.item.offset};
  `;
    return isFocused
        ? outlineStyle
        : css `
        &:focus {
          ${outlineStyle}
        }
      `;
};
export const ListBoxItemElement = styled.li.withConfig(suppressProps('isSelected', 'isFocused', 'disablePointerEvents'))(({ theme }) => css `
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: ${theme.styles.listBoxItems.base.cursor};
    padding: ${theme.space.x2} ${theme.space.x3};
  `, getListBoxItemInactiveStyles, getListBoxItemHoveredStyles, getListBoxItemFocusedStyles);
const getSelectedItemLabelStyles = ({ theme, isSelected, }) => {
    if (isSelected) {
        return css `
      color: ${theme.colors.controls[theme.styles.listBoxItems.states.active.color]};
    `;
    }
    return css ``;
};
export const ListBoxItemLabelElement = styled(Label)
    .withConfig(suppressProps('isSelected'))
    .attrs({
    elementType: 'span',
    variant: 'paragraph',
    color: 'inherit',
})(({ theme }) => css `
    cursor: ${theme.styles.listBoxItems.base.cursor};
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
  `, getSelectedItemLabelStyles);
export const ListBoxItemSelectedIconElement = styled.i(({ theme }) => css `
      margin-left: ${theme.space.x2};
      cursor: inherit;
      color: ${theme.colors.controls[theme.styles.listBoxItems.states.active.color]};
    `);
export const ListBoxItemSkeleton = styled(ListBoxItemLabelElement).attrs({
    loading: 'fullWidth',
    color: 'default',
})(({ theme }) => css `
    padding: ${theme.space.x1} ${theme.space.x0};
  `);
export const ListSection = styled.ul.withConfig(suppressProps('isUsingCheckbox'))(({ theme, isUsingCheckbox }) => css `
    padding: 0;
    & ${ListBoxItemElement} {
      padding-left: ${isUsingCheckbox
    ? theme.styles.listBoxes.section.withCheckbox.paddingLeft
    : theme.styles.listBoxes.section.withoutCheckbox.paddingLeft};
    }
  `);
export const ListSectionLabel = styled(TextElement)(({ theme }) => css `
    display: block;
    padding: ${theme.styles.listBoxes.sectionLabel.paddingY}
      ${theme.styles.listBoxes.sectionLabel.paddingX};
    text-transform: uppercase;
  `);
export const ListBoxEmptyStateWrapper = styled.li ``;
export const ListBoxEmptyState = styled(EmptyState)(({ theme }) => css `
    margin: ${theme.styles.listBoxes.emptyState.marginY}
      ${theme.styles.listBoxes.emptyState.marginX};
  `);
//# sourceMappingURL=list-box.styles.js.map